import Swiper from "swiper";

import { setCookie } from "../../../resources/js/helper/helper";

(function () {
  const filters = document.querySelectorAll(".single-product-filter");

  // const mbFilterslider = document.querySelectorAll(".filter-slider");
  // let filterSwiper = [];

  // for (let i = 0; i < mbFilterslider.length; i++) {
  //     filterSwiper[i] = new Swiper(mbFilterslider[i], {
  //     loop: false,
  //     slidesPerView: 'auto',
  //     spaceBetween: 25,
  //     freeMode: true,
  //     });
  // }

  for (let i = 0; i < filters.length; i++) {
    filters[i].addEventListener("click", function (event) {
      filterProducts(event.target);
      switchProductFilters(filters, event.target);
    });
  }

  function filterProducts(target) {
    const products = document.querySelectorAll(".single-product");

    for (let j = 0; j < products.length; j++) {
      if (products[j].classList.contains(target.dataset.productworld) || target.dataset.productworld === "all") {
        products[j].classList.add("active");
      } else {
        products[j].classList.remove("active");
      }
    }

    setCookie("product_cat", target.dataset.productworld, 1);
  }

  function switchProductFilters(filters, target) {
    for (let k = 0; k < filters.length; k++) {
      filters[k].classList.remove("active");
      target.classList.add("active");
    }
  }
})();
